import React, { Component } from 'react'
import styled from 'styled-components'
import Typography from '../Typography'
import { device } from '../../../utils/helpers'
import CaretIcon from '../Icons/CaretIcon'

const Wrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid #999999;
  padding: 20px 0;
`

const QuestionWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  cursor: pointer;
`

const Answer = styled.div`
  width: 100%;
`

const Caret = styled(CaretIcon)`
  width: 10px;
  ${''}

  @media ${device.mobileL} {
    width: 6px;
  }
`

class Question extends Component {
  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
  }

  toggleAnswer () {
    this.setState({ open: !this.state.open })
  }

  render () {
    const { question, answer } = this.props
    return (
      <Wrapper>
        <QuestionWrapper onClick={this.toggleAnswer.bind(this)}>
          <Typography minSize='16px' maxSize='24px'>
            {question}
          </Typography>
          <div>
            <Caret fill='#999999' transform={this.state.open ? 'rotate(90)' : undefined} />
          </div>
        </QuestionWrapper>
        {this.state.open && <Answer>
          <Typography padding='20px 0 0' minSize='16px' maxSize='24px'>
            {answer}
          </Typography>
        </Answer>}
      </Wrapper>
    )
  }
}

export default Question



// WEBPACK FOOTER //
// ./src/components/UI/Question/index.js